import React from 'react';
import Modal from 'react-bootstrap/Modal'
import { useTranslation } from 'react-i18next';

function TermsModal(props) {
    const { t } = useTranslation();
  return (
    <Modal show={props.show} onHide={props.onHide} >
      <Modal.Header>
        <Modal.Title>Locker Rental Terms</Modal.Title>
      </Modal.Header>
      <Modal.Body>
              {/* <p>
          {t('terms.part1')}
        </p>
        <p>
          {t('terms.part2')}
        </p>
        <p>
          {t('terms.part3')}
        </p> */}
              <p>
                  All storage charges are payable in advance.
              </p>
              <p>
                  Refunds are NOT permitted for early termination of the Contracted Storage Period. The customer understands and agrees to the dates of the Contracted Storage Period.
              </p>
              <p>
                  Items left after termination of the Contracted Storage Period shall be subject to removal and disposal.
              </p>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-primary" onClick={props.onHide}>Close</button>
      </Modal.Footer>
    </Modal>
  );
}

export { TermsModal }; 